import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { EventStore } from '../service/event.store';
import { OnyxEvent } from '../models/event';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class EventResolver implements Resolve<any> {
  constructor(private eventStore: EventStore,
              private translateService: TranslateService) {
  }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
    const id = route.params[ 'id' ];
    const eventPartyId = route.params[ 'eventPartyId' ];

    if (!id) {
      throw new Error(this.translateService.instant('MESSAGES.ERROR.GET_EVENT'));
    }

    if (eventPartyId) {
      return await this.eventStore.getEventByParty(route.params[ 'id' ], eventPartyId).toPromise();
    } else {
      return await this.eventStore.getEvent(route.params[ 'id' ]).toPromise();
    }
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/event/event.resolver.ts